export enum TableViewId {
    Leads = 'leads-table',
    Opportunities = 'opportunities-table',
    Offers = 'offers-table',
    Companies = 'companies-table',
    Contacts = 'contacts-table',
    Reservations = 'reservations-table',
    OnlineReservations = 'online-reservations-table',
    Reminders = 'reminders-table',
}

export const TABLE_VIEW_PAGE_NAME: Record<TableViewId, string> = {
    [TableViewId.Leads]: 'leads',
    [TableViewId.Opportunities]: 'opportunities',
    [TableViewId.Offers]: 'offers',
    [TableViewId.Companies]: 'companies',
    [TableViewId.Contacts]: 'contacts',
    [TableViewId.Reservations]: 'reservations',
    [TableViewId.OnlineReservations]: 'reservations',
    [TableViewId.Reminders]: 'reminders',
}
